import React, { useState, useEffect } from "react"

export const WistiaEmbed = ({ text }) => {
  const [embed_html, set_embed_html] = useState("")

  useEffect(() => {
    fetch(`https://fast.wistia.com/oembed?url=${text}`).then((api_resp) => {
      api_resp.ok && api_resp.json().then(({ html }) => set_embed_html(html))
    })
  }, []) //eslint-disable-line

  return <div dangerouslySetInnerHTML={{ __html: embed_html }}></div>
}
